export default "__VITE_ASSET__Avirz5rt__"